




















































import Vue from 'vue';
import { mapActions } from 'vuex';
import { get } from 'vuex-pathify';

import moment from 'moment';
import { Transition } from '@/models/transition';
import { ErrorManager } from '@/models/error';

import ErrorAlert from '../common/ErrorAlert.vue';
import RequestStatusDisplay from '../request-common/RequestStatusDisplay.vue';
import ALDialog from '../core/Dialog/ALDialog.vue';

import { ITimeOffRequest, ITimeOffRequestData, TimeOffRequest } from '@/models';

export default Vue.extend({
  name: 'TimeOffRequestActivityDialog',

  components: { ErrorAlert, RequestStatusDisplay, ALDialog },
  data: () => ({
    dialog: false,
    loading: false,

    errorMessage: '',
    detailErrorMessage: '',

    request: {} as ITimeOffRequestData,

    headers: [
      {
        text: 'Date',
        align: 'start',
        sortable: false,
        value: 'timestamp'
      },
      {
        text: 'Changed By',
        align: 'start',
        sortable: false,
        value: 'user'
      },
      {
        text: 'Previous State',
        align: 'center',
        sortable: false,
        value: 'source_state'
      },
      {
        text: 'Current State',
        align: 'center',
        sortable: false,
        value: 'state'
      }
    ]
  }),

  computed: {
    timeOffRequestActivities: get<Transition[]>(
      'timeOffRequest/getTimeOffRequestActivities'
    ),

    TimeOffRequest: () => TimeOffRequest
  },

  methods: {
    moment,

    ...mapActions({
      fetchTimeOffRequestActivities:
        'timeOffRequest/fetchTimeOffRequestActivities'
    }),

    clearAllErrors(): void {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    open(timeOffRequest: ITimeOffRequest) {
      this.clearAllErrors();

      this.request = timeOffRequest;

      this.dialog = true;
      this.loading = true;

      this.fetchTimeOffRequestActivities(timeOffRequest.id)
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    close() {
      this.dialog = false;
    }
  }
});
